

const Admin = {
  namespaced: true,
  state: {
    sessionAdmins: []
  },
  mutations: {
    setSessionAdmins(state, admins) {
      state.sessionAdmins = admins || []
    },
  },
  actions: {

  },
  getters: {
    getByProjectId: (state) => (id) => {
      const sessionAdmins = state.sessionAdmins || []
      return sessionAdmins.filter(admin => admin.project.objectId === id)
    },
    getByMarketId: (state) => (id) => {
      const sessionAdmins = state.sessionAdmins || []
      return sessionAdmins.find(admin => admin && admin.market && admin.market.objectId === id)
    },
  },
};
export default Admin;
